import type { OutboundMediaTipo } from '@/shared/types/midiaDeSaida';

/**
 * Teto de bytes por tipo de mídia: o limite do WhatsApp, espelho do MAX_MEDIA_BYTES do core
 * (src/domains/core/messaging/utils/mediaLimits.ts). Fonte única no front: o chat de atendimento
 * e o anexo da simulação aceitam o mesmo arquivo, e uma mudança do limite vale para os dois.
 */
export const MAX_MEDIA_BYTES: Record<OutboundMediaTipo, number> = {
  IMAGE: 5 * 1024 * 1024,
  VIDEO: 16 * 1024 * 1024,
  AUDIO: 16 * 1024 * 1024,
  DOCUMENT: 100 * 1024 * 1024,
};

/**
 * Bytes em MB para a mensagem de limite: inteiro sem casa decimal ("5", e não "5.0", que é o que o
 * `formatFileSize` de `@/shared/formatters` escreveria) e fração com uma casa.
 */
export const formatMb = (bytes: number): string => {
  const mb = bytes / (1024 * 1024);
  return Number.isInteger(mb) ? String(mb) : mb.toFixed(1);
};
